<template>
  <div class="schedule-modern">
    <NavBar />

    <div class="schedule-container">
      <!-- Header Section -->
      <div class="schedule-header">
        <div class="header-content">
          <div class="back-button-section">
            <v-btn class="btn-return" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2"></i>
              Voltar
            </v-btn>
          </div>

          <div class="title-section">
            <h1 class="page-title">
              <i class="fas fa-calendar-alt title-icon"></i>
              Agenda de Compromissos
            </h1>
            <p class="page-subtitle">
              Visualize e gerencie os agendamentos dos residentes
            </p>
          </div>

          <div class="actions-section">
            <v-btn class="btn-add-modern" @click="$bvModal.show('create')">
              <i class="fas fa-plus mr-2"></i>
              Novo Agendamento
            </v-btn>
          </div>
        </div>
      </div>

      <div class="filters-modern">
        <div class="col-md-6">
          <label class="filter-label">Residentes:</label>
          <v-select
            v-model="resident_id"
            :items="residents"
            item-text="name"
            item-value="id"
            clearable
            class="filter-select"
            @change="getSchedules"
          ></v-select>
        </div>

        <div class="col-md-6">
          <label class="filter-label">Tipo de Agendamento:</label>
          <v-select
            v-model="schedule_type_id"
            :items="schedules_types"
            item-text="name"
            item-value="id"
            clearable
            class="filter-select"
            @change="getSchedules"
          ></v-select>
        </div>
      </div>

      <div class="calendar-section">
        <Calendar
          :schedules="schedules"
          :month="month"
          :year="year"
          @update="handleUpdate"
          @selectedMonth="handleSelectedMonth"
        />
      </div>
    </div>

    <CreateModal
      :schedules_types="schedules_types"
      :residents="residents"
      :resident_id="Number(resident_id_for_modal)"
      @create="getSchedules"
    />

    <UpadateModal
      :schedules_types="schedules_types"
      :residents="residents"
      :schedule_id="schedule_id"
      @update="getSchedules"
    />
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import api from "../services/api";

import Calendar from "../templates/Schedule/Calendar";

import CreateModal from "../templates/Schedule/CreateModal";

import UpadateModal from "../templates/Schedule/UpadateModal";

import moment from "moment";

import routes from "../routes";

export default {
  name: "Schedule",
  components: {
    NavBar,
    Calendar,
    CreateModal,
    UpadateModal,
  },

  data() {
    return {
      schedule_id: null,

      resident_id: null,

      resident_id_for_modal: null,

      schedule_type_id: null,

      month: null,

      year: null,

      errors: [],

      schedules: [],

      schedules_types: [],

      residents: [],
    };
  },

  async created() {
    await this.getScheduleType();
    await this.getResidents();

    if (this.$route.query.resident_id) {
      this.resident_id = this.$route.query.resident_id;
    }

    if (this.$route.query.schedule_type_id) {
      this.schedule_type_id = this.$route.query.schedule_type_id;
    }

    let today = moment().format("YYYY-MM-DD");

    if (this.$route.query.date) {
      const date = moment(this.$route.query.date, "YYYY-MM-DD");

      if (date.isValid()) {
        this.month = date.month() + 1;
        this.year = date.year();
      }
    } else {
      const date = moment(today, "YYYY-MM-DD");

      if (date.isValid()) {
        this.month = date.month() + 1;
        this.year = date.year();
      }
    }

    await this.getSchedules();

    if (this.$route.query.resident_id_for_modal) {
      this.resident_id_for_modal = this.$route.query.resident_id_for_modal;

      this.$nextTick(() => {
        this.$bvModal.show("create");
      });
    }
  },

  methods: {
    async getSchedules() {
      try {
        const { schedule_type_id, resident_id, month, year } = this;

        let params = {
          resident_id,
          schedule_type_id,
          month,
          year,
        };

        const response = await api.get("/schedule/all", { params });

        const { schedules } = response.data;

        this.schedules = schedules;
      } catch (error) {
        console.error(error);
      }
    },

    async getScheduleType() {
      try {
        const response = await api.get("/schedule-type");

        const { error, schedules_types } = response.data;

        if (!error) {
          this.schedules_types = schedules_types;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async getResidents() {
      try {
        let params = { status_resident: "ATIVO" };

        const response = await api.get("/rest-home/residents", { params });

        const { error, residents } = response.data;

        if (!error) {
          this.residents = residents;
        }
      } catch (error) {
        console.error(error);
      }
    },

    handleUpdate(schedule_id) {
      this.schedule_id = schedule_id;

      this.$bvModal.show("update");
    },

    async handleSelectedMonth(month, year) {
      this.month = month;
      this.year = year;

      await this.getSchedules();
    },

    handleToBack: () => routes.go(-1),
  },
};
</script>

<style scoped>
.schedule-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.schedule-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Section */
.schedule-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.header-content {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 16px;
}

/* Button Styling */
.btn-add-modern {
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(78, 145, 48, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-add-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(78, 145, 48, 0.4) !important;
}

.btn-add-modern:active {
  transform: translateY(0) !important;
}

/* Calendar Section */
.calendar-section {
  margin-bottom: 32px;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .header-content {
    grid-template-columns: 1fr;
    gap: 16px;
    text-align: center;
  }

  .page-title {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .schedule-container {
    padding: 0 16px;
  }

  .schedule-header {
    padding: 20px 0;
    margin-bottom: 24px;
  }

  .header-content {
    padding: 0 16px;
  }

  .page-title {
    font-size: 24px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .btn-add-modern {
    padding: 10px 20px !important;
    font-size: 14px !important;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
    flex-direction: column;
    gap: 8px;
  }

  .title-icon {
    margin-right: 0;
  }

  .btn-add-modern {
    padding: 8px 16px !important;
    font-size: 13px !important;
    border-radius: 8px !important;
  }
}

.filters-modern {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(30, 41, 59, 0.06);
  padding: 5px 24px 1px 15px;
  margin: 25px 25px;
  display: flex;
  gap: 25px;
}

.filter-label {
  font-size: 16px;
  font-weight: 500;
  color: #1e293b;
  margin-bottom: 6px;
}

.filter-select >>> .vs__dropdown-toggle:focus,
.filter-select >>> .vs__dropdown-toggle:hover {
  border-color: #0f65b0;
}
</style>